/* eslint-disable consistent-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable import/no-duplicates */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import './confirmacion-pago.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import Preloader from '../layout/Preloader';
import ClientePaquetes from '../../api/paquetes';
import ClientePagos from '../../api/pagos';
import ClienteMail from '../../api/mail';
import ContactoAgenciaHorizontal from '../layout/contacto-agencia-horizontal/contacto-agencia-horizontal';
import PagoPendiente from './estados-pago/agencia-deposito/estado-pago-pendiente';
import PagoRechazado from './estados-pago/agencia-deposito/estado-pago-rechazado';
import PagoAprobado from './estados-pago/agencia-deposito/estado-pago-aceptado';
import PagoCancelado from './estados-pago/agencia-deposito/estado-pago-cancelado';
import PagoPendienteMp from './estados-pago/agencia-deposito/estado-pago-pendiente';
import PagoRechazadoMp from './estados-pago/agencia-deposito/estado-pago-rechazado';
import PagoAprobadoMp from './estados-pago/agencia-deposito/estado-pago-aceptado';
import PagoCanceladoMp from './estados-pago/agencia-deposito/estado-pago-cancelado';
import PagoAgencia from './forma-pago-seleccionada/pago-agencia';
import PagoMercadoPago from './forma-pago-seleccionada/pago-mercado-pago';
import PagoNoCompletado from './estados-pago/pago-no-completado';
import { getNavigation } from '../../redux/actions/application-actions';
import Error from '../../commons/error/error';
import DetalleRouter from './detalle-router';
import DatosComunes from './datos-comunes';

class ConfirmacionPago extends Component {
  static obtenerCodigoDeReserva() {
    return isClient ? window.location.pathname : ''.split('/')[3];
  }

  constructor(props) {
    super(props);
    this.estadosDePago = {
      1: PagoPendiente,
      2: PagoPendiente,
      3: PagoAprobado,
      4: PagoCancelado,
      5: PagoRechazado,
      '': '',
    };
    this.estadosDePagoMercadoPago = {
      1: PagoPendienteMp,
      2: PagoPendienteMp,
      3: PagoAprobadoMp,
      4: PagoCanceladoMp,
      5: PagoRechazadoMp,
      '': '',
    };
    this.eleccionDePago = {
      1: PagoAgencia,
      2: PagoMercadoPago,
      '': '',
    };
    this.state = {
      preloader: true,
      reserva: [],
      detallePaquete: [],
      estadoPago: '',
      canalPago: '',
      estadoReserva: '',
      estadoReservaNro: '',
      detallePago: '',
      datosFacturacion: '',
      pago: null,
      venta: null,
      moneda: '',
    };
    this.obtenerReserva = this.obtenerReserva.bind(this);
    this.obtenerPago = this.obtenerPago.bind(this);
    this.enviarMail = this.enviarMail.bind(this);
    this.analitycsEcommerce = this.analitycsEcommerce.bind(this);
    ConfirmacionPago.obtenerCodigoDeReserva = ConfirmacionPago.obtenerCodigoDeReserva.bind(this);
    this.setErrorGeneric = this.setErrorGeneric.bind(this);
  }

  componentDidMount() {
    this.props.actions.getNavigation();
    this.obtenerReserva().then((res) => {
      this.obtenerPago(res.data.id, res);
    });
  }

  setErrorGeneric() {
    this.setState({ error: true });
  }

  obtenerReserva() {
    const { token } = this.props.application;
    return ClientePaquetes.obtenerReserva(ConfirmacionPago.obtenerCodigoDeReserva(), token)
      .then((res) => {
        return res;
      })
      .catch(function (ex) {
        // eslint-disable-next-line no-console
        console.error('Error en ObtenerReserva. ', ex);
        this.setErrorGeneric();
      });
  }

  enviarMail() {
    const { token } = this.props.application;
    ClienteMail.enviarMail(ConfirmacionPago.obtenerCodigoDeReserva(), token)
      .then((res) => {
        this.analitycsEcommerce(res);
      })
      .catch((ex) => {
        // eslint-disable-next-line no-console
        console.error(ex);
        // eslint-disable-next-line no-console
        console.error('No se completo el envio de mail');
      });
  }

  analitycsEcommerce(res) {
    const { detallePaquete } = this.state;
    const { pago } = this.state;
    const { venta } = this.state;
    const { reserva } = this.state;
    let origen = 'Marca Blanca';
    let afiliado = isClient ? window.location.hostname : '';

    if (venta.Agencia !== null && venta.Agencia.Nombre !== undefined) {
      afiliado = venta.Agencia.Nombre;
      origen = 'Derivadora';
    }

    const transaction = {
      id: reserva.id,
      affiliation: afiliado,
      revenue: '0',
      shipping: '0',
      tax: '0',
      currency: 'ARS',
    };

    const item = { id: reserva.id,
      name: detallePaquete.nombre,
      sku: origen,
      category: 'Paquetes',
      price: pago.Importe,
      quantity: '1',
      currency: 'ARS',
    };

    if (res === true) {
      ReactGA.plugin.require('ecommerce', {});

      ReactGA.plugin.execute('ecommerce', 'addTransaction', transaction);
      ReactGA.plugin.execute('ecommerce', 'addItem', item);

      ReactGA.plugin.execute('ecommerce', 'send');
      ReactGA.plugin.execute('ecommerce', 'clear');
    }
  }

  obtenerPago(reservaId, resReserva) {
    const _this = this;
    const { token } = this.props.application;
    ClientePagos.obtenerDatosPagos(reservaId, token)
      .then((res) => {
        this.enviarMail();
        const pago = res.data;
        const reserva = resReserva.data;
        const moneda = (pago.monedaId === 1 || reserva.proveedorId === 11 || reserva.proveedorId === 7) ? 'ARS' : 'USD';
        const estadoPago = pago.canalPagoId === 1
          ? this.estadosDePago[pago.estadoPagoId]
          : this.estadosDePagoMercadoPago[pago.estadoPagoId];
        _this.setState({
          moneda,
          detallePago: pago,
          reserva,
          pago: JSON.parse(pago.pagoDetalle.detallePago),
          venta: JSON.parse(pago.pagoDetalle.detalleVenta),
          detallePaquete: JSON.parse(reserva.detallePaquete).paquete,
          preReserva: JSON.parse(reserva.detallePaquete).PreReserva,
          // estadoReserva: this.estadosDeReserva[reserva.estadoReserva],
          canalPago: this.eleccionDePago[pago.canalPagoId],
          estadoPago,
          estadoReservaNro: reserva.estadoReserva,
          preloader: false,
        });
      })
      .catch((ex) => {
        // eslint-disable-next-line no-console
        console.error('Error en ObtenerPago. ', ex);
        _this.setErrorGeneric();
      });
  }

  render() {
    if (this.state.error) {
      return <Error />;
    }

    const TituloReserva = this.state.estadoReservaNro === 1 || this.state.estadoReservaNro === 2
      ? (
        <span>
          <i className='fa fa-check-circle-o' />
          {' '}
          Tu reserva se ha realizado con éxito
        </span>
      )
      : (
        <span>
          <i className='fa fa-times-circle-o' />
          {' '}
          No pudimos confirmar tu reserva por favor contactate con nosotros para confirmarla
          {' '}
        </span>
      );

    const detallePaquete = (this.state.detallePaquete !== undefined)
      ? (
        <DetalleRouter paquete={this.state.detallePaquete} />
      )
    // eslint-disable-next-line no-console
      : console.log('detallePaquetes is undefined');

    const FormaPagoElegida = this.state.canalPago;

    const EstadoPago = this.state.estadoPago;

    const mostratNotaDolares = () => {
      if (this.state.detallePago.estadoPagoId !== 3) {
        return <PagoNoCompletado />;
      }
    };

    return this.state.preloader ? (
      <Preloader titulo='Preparando el detalle de su compra' />
    ) : (
      <div style={{ backgroundColor: '#f4f4f4' }}>

        <div className='container'>
          <h1 className='color-dinamico titulo-principal'>
            <b>{TituloReserva}</b>
          </h1>
          <FormaPagoElegida />
          <EstadoPago />

          {mostratNotaDolares()}

          {this.state.venta !== null && this.state.venta.Agencia !== null ? (
            <ContactoAgenciaHorizontal
              datosAgencia={this.state.venta}
              datos={this.state.reserva}
            />
          ) : ('')}
          <DatosComunes
            datosPago={this.state.pago}
            pasajeros={this.state.venta.Passengers}
            reservaId={this.state.reserva.id}
            total={this.state.pago.Importe}
            formaPago={this.state.pago.FormaPago}
            cuotas={this.state.pago.Cuotas}
            moneda={this.state.moneda}
          />
          {detallePaquete}
        </div>
      </div>
    );
  }
}
const mapStateToProps = function (store) {
  return {
    actualModule: store.applicationState.navigation.actualModule,
    application: store.applicationState,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    actions: bindActionCreators({ getNavigation }, dispatch),
  };
};

ConfirmacionPago.propTypes = {
  actions: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmacionPago);
